import { render, staticRenderFns } from "./PAGeneral.vue?vue&type=template&id=44d5432e&scoped=true&"
import script from "./PAGeneral.vue?vue&type=script&lang=js&"
export * from "./PAGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PAGeneral.vue?vue&type=style&index=0&id=44d5432e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5432e",
  null
  
)

component.options.__file = "PAGeneral.vue"
export default component.exports